/**
 * BOTANIC BLOOM THEME - JAVASCRIPT
 * Interactive features and functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ==========================================
  // MOBILE MENU
  // ==========================================
  
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuClose = document.querySelector('.mobile-menu-close');
  
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', function() {
      mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
  
  // Close mobile menu when clicking outside
  if (mobileMenu) {
    mobileMenu.addEventListener('click', function(e) {
      if (e.target === mobileMenu) {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
  
  
  // ==========================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ==========================================
  
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
  
  
  // ==========================================
  // PRODUCT IMAGE GALLERY
  // ==========================================
  
  const productThumbnails = document.querySelectorAll('.product-thumbnail');
  const mainProductImage = document.querySelector('.main-product-image img');
  
  productThumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      const newImageSrc = this.querySelector('img').src;
      if (mainProductImage) {
        mainProductImage.src = newImageSrc;
        
        // Update active state
        productThumbnails.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
      }
    });
  });
  
  
  // ==========================================
  // QUANTITY SELECTOR
  // ==========================================
  
  const quantityInputs = document.querySelectorAll('.quantity-input');
  
  quantityInputs.forEach(input => {
    const decreaseBtn = input.querySelector('.quantity-decrease');
    const increaseBtn = input.querySelector('.quantity-increase');
    const numberInput = input.querySelector('input[type="number"]');
    
    if (decreaseBtn && numberInput) {
      decreaseBtn.addEventListener('click', function() {
        const currentValue = parseInt(numberInput.value);
        if (currentValue > 1) {
          numberInput.value = currentValue - 1;
        }
      });
    }
    
    if (increaseBtn && numberInput) {
      increaseBtn.addEventListener('click', function() {
        const currentValue = parseInt(numberInput.value);
        numberInput.value = currentValue + 1;
      });
    }
  });
  
  
  // ==========================================
  // COLLECTION FILTERS
  // ==========================================
  
  const filterToggles = document.querySelectorAll('.filter-toggle');
  
  filterToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const filterContent = this.nextElementSibling;
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      this.setAttribute('aria-expanded', !isExpanded);
      filterContent.style.maxHeight = isExpanded ? '0' : filterContent.scrollHeight + 'px';
    });
  });
  
  
  // ==========================================
  // ANNOUNCEMENT BAR CLOSE
  // ==========================================
  
  const announcementClose = document.querySelector('.announcement-close');
  const announcementBar = document.querySelector('.announcement-bar');
  
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', function() {
      announcementBar.style.display = 'none';
      localStorage.setItem('announcement-closed', 'true');
    });
    
    // Check if announcement was previously closed
    if (localStorage.getItem('announcement-closed') === 'true') {
      announcementBar.style.display = 'none';
    }
  }
  
  
  // ==========================================
  // LAZY LOADING IMAGES
  // ==========================================
  
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src || img.src;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  }
  
  
  // ==========================================
  // SCROLL TO TOP BUTTON
  // ==========================================
  
  const scrollToTopBtn = document.querySelector('.scroll-to-top');
  
  if (scrollToTopBtn) {
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 300) {
        scrollToTopBtn.classList.add('visible');
      } else {
        scrollToTopBtn.classList.remove('visible');
      }
    });
    
    scrollToTopBtn.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
  
  
  // ==========================================
  // HEADER SCROLL EFFECT
  // ==========================================
  
  const siteHeader = document.querySelector('.site-header');
  let lastScroll = 0;
  
  if (siteHeader) {
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      
      if (currentScroll > 100) {
        siteHeader.classList.add('scrolled');
      } else {
        siteHeader.classList.remove('scrolled');
      }
      
      lastScroll = currentScroll;
    });
  }
  
  
  // ==========================================
  // SEARCH FUNCTIONALITY
  // ==========================================
  
  const searchToggle = document.querySelector('.search-toggle');
  const searchOverlay = document.querySelector('.search-overlay');
  const searchClose = document.querySelector('.search-close');
  
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      searchOverlay.classList.add('active');
      const searchInput = searchOverlay.querySelector('input');
      if (searchInput) {
        searchInput.focus();
      }
    });
  }
  
  if (searchClose && searchOverlay) {
    searchClose.addEventListener('click', function() {
      searchOverlay.classList.remove('active');
    });
  }
  
  
  // ==========================================
  // FORM VALIDATION
  // ==========================================
  
  const forms = document.querySelectorAll('form[data-validate]');
  
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      const emailInput = form.querySelector('input[type="email"]');
      
      if (emailInput && !isValidEmail(emailInput.value)) {
        e.preventDefault();
        showError(emailInput, 'Please enter a valid email address');
      }
    });
  });
  
  function isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
  
  function showError(input, message) {
    const errorDiv = document.createElement('div');
    errorDiv.className = 'form-error';
    errorDiv.textContent = message;
    
    // Remove existing error if any
    const existingError = input.parentElement.querySelector('.form-error');
    if (existingError) {
      existingError.remove();
    }
    
    input.parentElement.appendChild(errorDiv);
    input.classList.add('error');
    
    // Remove error on input
    input.addEventListener('input', function() {
      errorDiv.remove();
      input.classList.remove('error');
    }, { once: true });
  }
});
/* ===========================
   SEARCH POPUP JAVASCRIPT
   Add this to your theme.js file or in header.liquid inside <script> tags
   =========================== */

document.addEventListener('DOMContentLoaded', function() {
  // Create search popup HTML
  const searchPopupHTML = `
    <div class="search-popup-overlay" id="searchOverlay"></div>
    <div class="search-popup" id="searchPopup">
      <div class="search-popup-header">
        <h3>Search Products</h3>
        <button class="search-close-btn" id="searchCloseBtn">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      
      <div class="search-popup-form">
        <form action="/search" method="get">
          <div class="search-popup-input-wrapper">
            <input 
              type="text" 
              name="q" 
              placeholder="Search for flowers..." 
              class="search-popup-input"
              autocomplete="off"
            >
            <button type="submit" class="search-submit-btn">
              <svg viewBox="0 0 24 24" fill="none">
                <circle cx="11" cy="11" r="8" stroke-width="2"/>
                <path d="m21 21-4.35-4.35" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </form>
        
        <div class="search-quick-links">
          <h4>Popular Searches</h4>
          <a href="/collections/roses">Roses</a>
          <a href="/collections/peonies">Peonies</a>
          <a href="/collections/wedding">Wedding Bouquets</a>
          <a href="/collections/bestsellers">Best Sellers</a>
        </div>
      </div>
    </div>
  `;
  
  // Add search popup to body
  document.body.insertAdjacentHTML('beforeend', searchPopupHTML);
  
  // Get elements
  const searchBtn = document.getElementById('searchIconBtn');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchPopup = document.getElementById('searchPopup');
  const searchCloseBtn = document.getElementById('searchCloseBtn');
  const searchInput = document.querySelector('.search-popup-input');
  
  // Open popup
  if (searchBtn) {
    searchBtn.addEventListener('click', function() {
      searchOverlay.classList.add('active');
      searchPopup.classList.add('active');
      setTimeout(() => searchInput.focus(), 300);
    });
  }
  
  // Close popup
  function closeSearch() {
    searchOverlay.classList.remove('active');
    searchPopup.classList.remove('active');
  }
  
  searchCloseBtn.addEventListener('click', closeSearch);
  searchOverlay.addEventListener('click', closeSearch);
  
  // Close on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchPopup.classList.contains('active')) {
      closeSearch();
    }
  });
});